import React from 'react';
import PropTypes from 'prop-types';
import AchievementsTrophyNormalLarge from '@strava/icons/AchievementsTrophyNormalLarge';
import { useLoggedOutAthletePageContext } from '../../../../state/LoggedOutAthletePageContext';
import styles from './EmptyTrophyCase.module.scss';

const EmptyTrophyCase = ({ athleteName, followUrl }) => {
  const { t } = useLoggedOutAthletePageContext();

  return (
    <div className={styles.emptyTrophyCase}>
      <AchievementsTrophyNormalLarge />
      <p>
        <a href={followUrl}>
          {t('trophy_empty_state', {
            athlete_name: athleteName
          })}
        </a>
      </p>
    </div>
  );
};

EmptyTrophyCase.propTypes = {
  athleteName: PropTypes.string.isRequired,
  followUrl: PropTypes.string.isRequired
};

export default EmptyTrophyCase;
